// src/configs/msalConfig.js (or wherever this currently lives)
import config from "./config";

export const msalConfig = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
    redirectUri: config.REDIRECT_URL,
    postLogoutRedirectUri: config.POSTREDIRECT_URL,
    // Prevents MSAL from replaying the exact URL the login was started
    // from after a redirect — reduces open-redirect style risk.
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // SECURITY TRADEOFF:
    // - "localStorage" (current setting) persists across tabs and browser
    //   restarts, but is readable by ANY JS running on the page - including
    //   injected/XSS scripts - for as long as it sits there.
    // - "sessionStorage" is the standard MSAL recommendation for public
    //   SPAs, but it's cleared the moment a tab closes and isn't shared
    //   across tabs - with this app's own login state kept separately in
    //   localStorage (apiService.js), that mismatch meant MSAL had no
    //   cached account left to silently refresh with after a tab
    //   close/reopen, so the first token expiry (~1h) after that forced a
    //   full logout well before the real 7-day session cap. localStorage
    //   keeps both in the same place, so silent refresh survives a reopen.
    // Make sure a strong CSP is in place to limit XSS blast radius.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    // Disables native broker auth (Windows Hello / native account picker)
    // unless you've explicitly set this app up for it — keeps the auth
    // surface area smaller and predictable.
    allowNativeBroker: false,
  },
};

export default msalConfig;